import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../config";
import fallback from "./mcpCatalogFallback.json";

/** Live tool catalogue from the server (single source of truth); static copy if the request fails. */
export function useMcpCatalog() {
  const [state, setState] = useState({ catalog: fallback, live: false, loading: true });
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/mcp/catalog`, { timeout: 10000 })
      .then(({ data }) => { if (alive && Array.isArray(data?.tools) && data.tools.length) setState({ catalog: data, live: true, loading: false }); else if (alive) setState((s) => ({ ...s, loading: false })); })
      .catch(() => { if (alive) setState((s) => ({ ...s, loading: false })); });
    return () => { alive = false; };
  }, []);
  return state;
}

export const TIER_COLORS = { open: { fg: "#006874", bg: "#e6f1f2" }, pro: { fg: "#7c3aed", bg: "#f3e8ff" } };

export const TierBadge = ({ tier }) => {
  const c = TIER_COLORS[tier] || TIER_COLORS.open;
  return <span data-testid={`mcp-tier-badge-${tier}`} style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: c.fg, background: c.bg, borderRadius: 999, padding: "2px 8px" }}>{tier}</span>;
};
